import React from 'react';
import { TintedStatusPill } from '../../ui/core';
import { CarIcon, InfoIcon, EventIcon, CheckCircleIcon, RideIcon } from '../../ui/icons';

export const FleetVehicleStatusOptions = [
  { label: 'Available', value: 'AVAILABLE' },
  { label: 'Unavailable', value: 'UNAVAILABLE' },
];

export const getVehicleDisplayStatus = (vehicle) => {
  if (!vehicle) return 'AVAILABLE';
  if (vehicle.isOperational === false) return 'UNAVAILABLE';
  if (Array.isArray(vehicle.assignments) && vehicle.assignments.length > 0) return 'IN_USE';
  return 'AVAILABLE';
};

// Theme-aware status chip: a soft tinted pill that derives its color from the
// theme palette so it reads correctly in both light and dark mode (the old
// version hardcoded light-only hex values). Rendering is delegated to the
// shared TintedStatusPill so this recipe isn't re-derived per caller.
const DisplayStatusChip = ({ value }) => {
  const config = {
    AVAILABLE: { palette: 'success', label: 'Available' },
    IN_USE: { palette: 'accent', label: 'In Use' },
    UNAVAILABLE: { palette: 'error', label: 'Unavailable' },
  };
  const cfg = config[value] || config.AVAILABLE;
  return <TintedStatusPill palette={cfg.palette} label={cfg.label} />;
};

export const VehicleColumns = [
  { field: 'id', hide: true },
  { field: 'displayName', headerName: 'Name', headerIcon: <CarIcon />, flex: 1, minWidth: 170 },
  { field: 'make', headerName: 'Make', headerIcon: <InfoIcon />, flex: 0.7, minWidth: 130 },
  { field: 'model', headerName: 'Model', headerIcon: <InfoIcon />, flex: 0.7, minWidth: 140 },
  { field: 'year', headerName: 'Year', headerIcon: <EventIcon />, width: 110 },
  {
    field: 'displayStatus',
    headerName: 'Status',
    headerIcon: <CheckCircleIcon />,
    width: 150,
    valueGetter: ({ row }) => getVehicleDisplayStatus(row),
    renderCell: ({ row }) => <DisplayStatusChip value={getVehicleDisplayStatus(row)} />,
  },
  {
    field: 'assignmentCount',
    headerName: 'Assigned Trips',
    headerIcon: <RideIcon />,
    width: 180,
    valueGetter: ({ row }) => (Array.isArray(row.assignments) ? row.assignments.length : 0),
  },
];
